<template>
  <Select
    :items="ufs"
    :selectedItem="filter.uf"
    label="UF"
    searchPlaceholder="Buscar UF"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        uf: {
          id: "",
          name: "",
        },
      },
      ufs: [],
    };
  },
  methods: {
    atualizar(uf) {
      this.filter.uf = uf;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.uf.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.uf.id
      });
    },
  },
  mounted() {
    this.$api.get("/ufs").then((response) => {
      const { ufs } = response.data;
      this.ufs = ufs.map(uf => ({
        id: uf.id,
        name: uf.nome
      }));

      const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
      this.$renderFiltroSelect(filtroAplicado, this.ufs, this.filter.uf);
    });
  }
}
</script>
